import React from 'react'

import useCustomerDetail from 'hooks/useCustomerDetail'
import Spinner from 'components/Spinner'
import styled from 'styled-components'
import ColumnGridPanel from 'components/ColumnGridPanel'

import { screenSize } from 'styles/shared'

type Props = {
  deviceId: string
}

const Customer = ({ deviceId }: Props) => {
  const { customer, diagContact, homeContact, diagAddress, homeAddress, isCustomerLoaded } = useCustomerDetail(deviceId)

  if (!isCustomerLoaded) {
    return <Spinner variant="page" />
  }

  return (
    <S.Form>
      <S.DetailColumn>
        <h3>CUSTOMER TABLE</h3>

        {customer?.map(customerInfo => (
          <ColumnGridPanel.Column.Item key={customerInfo.column} label={customerInfo.column} value={customerInfo.value} />
        ))}
      </S.DetailColumn>

      <S.DetailColumn>
        <h3>DIAGNOSTICS PII CONTACT</h3>

        {diagContact?.map(diagPII => (
          <ColumnGridPanel.Column.Item key={diagPII.column} label={diagPII.column} value={diagPII.value} />
        ))}

        <S.Container>
          <h3>DIAGNOSTICS PII ADDRESS</h3>

          {diagAddress?.map(diagPII => (
            <ColumnGridPanel.Column.Item key={diagPII.column} label={diagPII.column} value={diagPII.value} />
          ))}
        </S.Container>
      </S.DetailColumn>

      <S.DetailColumn>
        <h3>HOME PII</h3>

        {homeContact?.map(homePII => (
          <ColumnGridPanel.Column.Item key={homePII.column} label={homePII.column} value={homePII.value} />
        ))}

        <S.Container>
          <h3>HOME PII ADDRESS</h3>

          {homeAddress?.map(homePII => (
            <ColumnGridPanel.Column.Item key={homePII.column} label={homePII.column} value={homePII.value} />
          ))}
        </S.Container>
      </S.DetailColumn>
    </S.Form>
  )
}

export default Customer

const S = {
  Form: styled.form`
    display: flex;
    padding: 40px 20px;
    grid-column-gap: 50px;
    flex-wrap: wrap;
    justify-content: space-between;
  `,
  Container: styled.div`
    padding: 20px 0;
  `,
  DetailColumn: styled.div`
    flex: 1;
    padding: 20px;
    word-wrap: break-word;
    
    @media ${screenSize.mediumOnly} {
      flex: 1 1 30%;
    }
    @media ${screenSize.small} {
      flex: 1 1 100%;
    }
    
  `
}
